import { BADGE_PHOTO_URL } from '../constants/grimsby';

/**
 * Method to get the phonetool photo for a user
 * @return {string} Returns the badge photo src
 */
export const getBadgePhoto = (alias: string): string => BADGE_PHOTO_URL + alias;

export default getBadgePhoto;
